import CountrieFolderIcon from './component'

export default CountrieFolderIcon
